<template>
    <transition name="drop-navigation" appear>
        <div class="drop-nav">
            <template v-if="currentPanel < 3">
                <ul>
                    <li v-for="(panel, index) in panels"
                        :class="index === currentPanel ? 'is-active' : ''"
                        @click="panelChange(index)">
                    </li>
                </ul>
            </template>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['currentPanel', 'numberOfPanels', 'panels'],
        methods: {
            panelChange(index) {
                this.eventHub.$emit('panelChange', index);
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import './../../assets/scss/animations/sliding';
    @import './../../assets/scss/dimensions';

    .drop-nav {
        left: 50%;
        margin-left: -24px;
        position: absolute;
        top: 35px;
        width: 42px;

        ul {
            list-style-type: none;
            margin: 16px 0;
            text-align: center;

            li {
                background: #FFFFFF;
                border-radius: 100px;
                cursor: pointer;
                display: inline-block;
                height: 5px;
                margin-right: 6px;
                opacity: 0.5;
                transition: all linear .5s;
                width: 5px;

                &:last-child {
                    margin-right: 0;
                }

                @media(min-width: 1024px) {
                    height: 6px;
                    width: 6px;
                }

                &.is-active {
                    opacity: 1;
                    width: 17px;
                }
            }
        }
    }

    .drop-navigation-enter-active {
        animation: slideToBottomIn 1s ease-out;
    }


</style>


// WEBPACK FOOTER //
// src/components/panels/DropNavigation.vue